/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';

import { Button } from 'uikit/buttons';
import { Grid, Row, Column } from 'uikit/grids';
import { Skeleton } from 'uikit/loaders';
import { Typo } from 'uikit/content';

import ProfileSkillsListItem from './profileSkillsListItem';

import styles from '../styles/profileSkillsList.module.scss';

const ProfileSkillsList = ({
  skills,
  initialSkillsCount,
  isLoading,
  isShowingAllSkills,
  isShowingExpandButton,
  onShowAllSkillsClick,
}) =>
  isLoading ? (
    <Grid>
      <Row sizes={{ default: 1, small: 2 }}>
        {[...Array(initialSkillsCount).keys()].map((_, index) => (
          <Column key={index}>
            <Skeleton width="100%" height={42} />
          </Column>
        ))}
      </Row>
    </Grid>
  ) : skills?.length ? (
    <>
      <Grid>
        <Row sizes={{ default: 1, small: 2 }}>
          {skills.map((skill) => (
            <Column key={skill.id}>
              <ProfileSkillsListItem skill={skill} />
            </Column>
          ))}
        </Row>
      </Grid>
      {isShowingExpandButton && (
        <div className={styles.actions}>
          <Button
            icon={isShowingAllSkills ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            iconPosition="right"
            text={isShowingAllSkills ? i18n.t('show-fewer-skills') : i18n.t('show-more-skills')}
            variant="soft"
            onClick={onShowAllSkillsClick}
          />
        </div>
      )}
    </>
  ) : (
    <div className={styles.placeholder}>
      <Typo element="h2" variant="d02">
        {i18n.t('gain-skills-and-reputation')}
      </Typo>
      <Typo color="secondary" element="p" variant="b01">
        {i18n.t('gain-skills-and-reputation-description')}
      </Typo>
    </div>
  );

ProfileSkillsList.propTypes = {
  skills: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      reputation_points: PropTypes.number.isRequired,
      hex_color: PropTypes.string.isRequired,
    }),
  ).isRequired,
  initialSkillsCount: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isShowingAllSkills: PropTypes.bool.isRequired,
  isShowingExpandButton: PropTypes.bool.isRequired,
  onShowAllSkillsClick: PropTypes.func.isRequired,
};

export default React.memo(ProfileSkillsList);
